import { Currency } from '@seapoint/server/enums';
import { Stack } from '../../../design-system/stack/stack';
import { cn } from '../../../utils/cn';
import { getAmountWithCurrency } from '../../../utils/get-amount-with-currency';

type AccountsSummaryProps = {
  currency: Currency;
  accountBalance: number;
  isSelected?: boolean;
  onResetSelectedAccount?: () => void;
};

export const AllAccountsSummaryCard = ({
  currency,
  accountBalance,
  isSelected,
  onResetSelectedAccount,
}: AccountsSummaryProps) => {
  const balanceAmount = getAmountWithCurrency({ amount: accountBalance, currency, isAccountBalance: true });

  return (
    <div
      className={cn(
        'flex w-52 cursor-pointer flex-col justify-between rounded-lg border-2 bg-white px-5 py-4 shadow-sm transition-all duration-200 hover:shadow-md',
        isSelected ? 'border-seapoint-yellow' : 'border-transparent bg-seapoint-gray-background-modal',
      )}
      onClick={onResetSelectedAccount}
    >
      <Stack space={2}>
        <p className="text-base font-medium text-black">Account balance</p>
        <p className="text-xl font-medium text-black">{balanceAmount}</p>
      </Stack>
    </div>
  );
};
